export type HeaderLinkBadgeProps = {
  value: number
}

export const HeaderLinkBadge = ({ value }: HeaderLinkBadgeProps) => {
  if (!value) {
    return null
  }

  return (
    <div className="bg-brand-primary absolute top-0 right-0 flex h-5 w-5 items-center justify-center rounded-full text-xs text-white shadow-sm">
      {value}
    </div>
  )
}
